// extracted by css-extract-rspack-plugin
export default {"temConnectionContent":"src-domain-components-tem-connection-modal-body-temConnectionModalBody-module__temConnectionContent-uZnUXE","connectingSubtitle":"src-domain-components-tem-connection-modal-body-temConnectionModalBody-module__connectingSubtitle-gjr2i8","temConnectionInfoRow":"src-domain-components-tem-connection-modal-body-temConnectionModalBody-module__temConnectionInfoRow-NrN4Bi","bannerContainer":"src-domain-components-tem-connection-modal-body-temConnectionModalBody-module__bannerContainer-ifYRkd","retryButton":"src-domain-components-tem-connection-modal-body-temConnectionModalBody-module__retryButton-wHNuVC"};
    if(module.hot) {
      (function() {
        var localsJsonString = "{\"temConnectionContent\":\"src-domain-components-tem-connection-modal-body-temConnectionModalBody-module__temConnectionContent-uZnUXE\",\"connectingSubtitle\":\"src-domain-components-tem-connection-modal-body-temConnectionModalBody-module__connectingSubtitle-gjr2i8\",\"temConnectionInfoRow\":\"src-domain-components-tem-connection-modal-body-temConnectionModalBody-module__temConnectionInfoRow-NrN4Bi\",\"bannerContainer\":\"src-domain-components-tem-connection-modal-body-temConnectionModalBody-module__bannerContainer-ifYRkd\",\"retryButton\":\"src-domain-components-tem-connection-modal-body-temConnectionModalBody-module__retryButton-wHNuVC\"}";
        // 1793705033135
        var cssReload = require("../../../../../node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  